export default {"src":"/_next/static/media/paper-shredding.4cb443f9.svg","height":72,"width":72};